import type {CSSProperties} from 'react';
import {font, radius, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeBlipLook = 'blip-listen' | 'blip-listen-on';

const BLIP_LOOKS = new Set<string>(['blip-listen', 'blip-listen-on']);
export const isWedgeBlipLook = (look: string): look is WedgeBlipLook => BLIP_LOOKS.has(look);

/* Released Blip answer bubble (Wedge): the Listen pill under an answer. It is a centered inline row of a glyph and a label with a 6px gap,
   36px tall at least and 44px wide at least, 8px by 14px of padding, a full pill radius, a 1px amber border and 12px bold type. Idle it is
   transparent with amber ink; `blip-listen-on` (the answer is being read aloud, so the button reads Stop) fills with amber and prints the
   on-accent ink. Each reads the exact legacy roles, and the declaration order is the order of the source. The caller owns the glyph, the
   label, `aria-pressed`, the handler and the row. The pill is 36px tall, not 44px: it keeps its released box. */
const MIN_HEIGHT = 36, MIN_WIDTH = 44, PADDING = '8px 14px', GAP = 6;

export function wedgeBlipStyle(look: WedgeBlipLook): CSSProperties {
  const r = wedgeExactRole;
  const on = look === 'blip-listen-on';
  return {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: GAP, minHeight: MIN_HEIGHT, minWidth: MIN_WIDTH,
    padding: PADDING, borderRadius: radius.pill, background: on ? r('amber') : 'transparent', color: on ? r('onAccent') : r('amber'),
    border: `1px solid ${r('amber')}`, fontSize: font.caption, fontWeight: weight.bold, cursor: 'pointer', WebkitTapHighlightColor: 'transparent',
  };
}
